import React, { useState, useRef, useEffect } from "react";
import Logo from "./../../assets/images/logo.png";
import ReCAPTCHA from "react-google-recaptcha";
import SimpleReactValidator from "simple-react-validator";
import { Link } from "react-router-dom";
import * as api from "./../../api/api";
import Company from "./../register/companyDetails";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

const initialFormData = {
  fullName: "",
  email: "",
  password: "",
  confirmPassword: "",
  reCaptcha: "",
};

const TEST_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

export default function Register(props) {
  const classes = useStyles();
  const simpleValidator = useRef(new SimpleReactValidator());
  const [formData, setFormData] = useState(initialFormData);
  const [id, setId] = useState("");
  const [checked, setChecked] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(true);
  const [company, setCompany] = useState(false);
  const [loader, setLoader] = useState(false);
  // const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [error, setError] = useState(false);
  useEffect(() => {
    document.title = "121five.com - Register";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleConfirmPassword = (e) => {
    const { value } = e.target;
    if (formData.password === value) {
      setConfirmPassword(true);
    } else {
      setConfirmPassword(false);
    }
  };
  const handleSubmit = async () => {
    const { fullName, email, password, reCaptcha } = formData;
    setLoader(true);

    if (simpleValidator.current.allValid() && reCaptcha) {
      if (checked && confirmPassword) {
        try {
          const reqObject = {};
          reqObject.name = fullName;
          reqObject.email_id = email;
          reqObject.password = password;
          const response = await api.register(reqObject);
          if (response.data) {
            setId(response.data.id);
            localStorage.setItem("isAuth", true);
            localStorage.setItem("userName", response.data.name);
            localStorage.setItem("email", response.data.email);
            localStorage.setItem("id", response.data.id);
            setCompany(true);
            setLoader(false);
          }
        } catch (e) {}
      } else {
        setLoader(false);
      }
    } else {
      simpleValidator.current.showMessages();
      setError(true);
      setLoader(false);
    }
  };

  const onCaptchaChange = (e) => {
    setFormData({
      ...formData,
      reCaptcha: e,
    });
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth">
          <div className="row flex-grow">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left p-5">
                <Link to="/">
                  <div className="brand-logo">
                    <img src={Logo} alt="Logo" />
                  </div>
                </Link>

                {!company ? (
                  <div>
                    <h4>New here?</h4>
                    <h6 className="font-weight-light">
                      Signing up is easy. It only takes a few steps
                    </h6>
                    <form className="pt-3">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          placeholder="Full Name"
                          name="fullName"
                          onChange={handleChange}
                        />
                        {simpleValidator.current.message(
                          "fullName",
                          formData.fullName,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control form-control-lg"
                          placeholder="Email"
                          name="email"
                          onChange={handleChange}
                        />
                        {simpleValidator.current.message(
                          "email",
                          formData.email,
                          "required|email",
                          { className: "text-danger" }
                        )}
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control form-control-lg"
                          placeholder="Password"
                          name="password"
                          onChange={handleChange}
                        />
                        {simpleValidator.current.message(
                          "password",
                          formData.password,
                          "required|min:8|max:32",
                          { className: "text-danger" }
                        )}
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control form-control-lg"
                          placeholder="Confirm Password"
                          name="confirmPassword"
                          onBlur={handleConfirmPassword}
                        />
                      </div>
                      {confirmPassword ? (
                        ""
                      ) : (
                        <div className=" text-danger pb-3">
                          Password doesn't match
                        </div>
                      )}

                      <div className="form-group">
                        <ReCAPTCHA
                          sitekey={TEST_SITE_KEY}
                          onChange={onCaptchaChange}
                        />
                        {error ? (
                          <span
                            className="text-danger"
                            style={{ fontSize: "14px" }}
                          >
                            Click on the reCaptcha
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="mb-4">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            onClick={() => setChecked(!checked)}
                          />
                          <label className="form-check-label text-muted">
                            I agree to all{" "}
                            <Link to="/terms-of-use">Terms & Conditions</Link>
                          </label>
                        </div>
                      </div>
                    </form>
                    <div className="mt-3">
                      <div
                        className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                        onClick={handleSubmit}
                      >
                        SIGN UP
                      </div>
                    </div>
                    <div className="text-center mt-4 font-weight-light">
                      <Link to="/login">
                        {" "}
                        Already have an account?{" "}
                        {/* <a href="#" className="text-primary"> */}
                        Login
                        {/* </a> */}
                      </Link>
                    </div>
                  </div>
                ) : (
                  <Company id={id} name={formData.fullName} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
